import { Checkbox } from '@xo-union/tk-component-switches';
import React from 'react';

import { Household } from './AddGuestRail';
import styles from './householdRow.scss';
import { findLeader } from '../../helpers/households';

interface Props {
  household: Household;
  onSelect?: Function;
  isSelected?: boolean;
  setGuestRailOpen?: Function;
  setEditHousehold?: Function;
  validateType?: 'email' | 'phone';
  disableCheckbox?: boolean;
}

const HouseholdRow: React.FC<Props> = ({
  household,
  onSelect,
  isSelected,
  setGuestRailOpen,
  setEditHousehold,
  validateType = 'email',
  disableCheckbox = false,
}) => {
  const leader = findLeader(household);

  const hasContactInfo = !!leader![validateType];
  const householdSize = household ? household.people.length : 0;

  return (
    <div className={`${styles.householdRow} ${hasContactInfo ? '' : styles.missingEmail}`}>
      {hasContactInfo && !disableCheckbox ? (
        <div className={styles.checkbox}>
          <Checkbox
            data-testid={`checkbox-${leader?.id}`}
            onChange={onSelect}
            checked={isSelected}
            value={leader?.id}
          />
        </div>
      ) : null}
      <div className={styles.householdInfo}>
        <div className={styles.leaderName}>
          <span>
            {leader!.firstName} {leader!.lastName}
          </span>
          <span>{householdSize > 1 ? ` + ${householdSize - 1} guest${householdSize > 2 ? 's' : ''}` : ''}</span>
        </div>
        {hasContactInfo ? <div className={styles.leaderEmail}>{leader![validateType]}</div> : null}
      </div>
      {hasContactInfo ? null : (
        <div
          className={styles.addEmailButton}
          onClick={
            setGuestRailOpen && setEditHousehold
              ? () => {
                  setEditHousehold(household);
                  setGuestRailOpen(true);
                }
              : undefined
          }
        >
          <span>Add {validateType === 'email' ? 'email address' : 'phone number'} </span>
        </div>
      )}
    </div>
  );
};

export default HouseholdRow;
